import React, { useEffect, useState } from 'react';
import {
  InternalUsersManagementHeader,
  Container,
  InternalUsersTableContainer,
  AddUserContainer
} from './styles';
import { Title } from '@gerdau/hefesto/Title';
import { Button } from '@gerdau/hefesto/Button';
import { Skeleton } from '@gerdau/hefesto/Skeleton';
import { Icon } from '@gerdau/hefesto/Icon';

import InternalUsersTable from './InternalUsersTable';
import AddInternalUserModal from './InternalUsersTable/AddInternalUserModal';
import { AccessInternalManagementService } from '../../services/AccessInternalManagement';
import InternalUsersFilter from './InternalUsersFilter';
import { IInternalUser } from '../../store/ducks/internal-user/types';
import { useDispatch, useSelector } from 'react-redux';
import { addToast } from '../../store/ducks/toast/actions';
import { EToastTypes } from '../../store/ducks/toast/types';
import { ApplicationState } from '../../store';
import { GetFlag } from '../../utils/featureFlag';

export interface IToastMessage {
  message: string;
  type: 'success' | 'warning' | 'danger' | 'info';
}

const AccessInternalManagement: React.FC = () => {
  const dispatch = useDispatch();
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [internalUsers, setInternalUsers] = useState<IInternalUser[]>([]);
  const [filteredInternalUsers, setFilteredInternalUsers] = useState<
    IInternalUser[]
  >([]);
  const [loading, setLoading] = useState(true);

  const flagIgnoreRestrictions = GetFlag('ignore_user_management_restrictions');

  const restrictedToManageUsers =
    useSelector(
      (state: ApplicationState) => state.user.userRestrictions.usersManagement
    ) && !flagIgnoreRestrictions;

  useEffect(() => {
    AccessInternalManagementService.getSellerReps()
      .then((response: IInternalUser[]) => {
        setInternalUsers(response);
      })
      .catch((error) => {
        console.error(error);
        dispatch(
          addToast({
            message: 'Erro ao carregar os vendedores.',
            type: EToastTypes.DANGER
          })
        );
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (internalUsers) {
      setFilteredInternalUsers(internalUsers);
    }
  }, [internalUsers]);

  return (
    <>
      <InternalUsersManagementHeader>
        <Title level={1}>Gestão de usuários internos</Title>
        <span className="description-facelift">
          Área dedicada para a gestão dos usuários internos.
        </span>
        <InternalUsersFilter
          internalUsers={internalUsers}
          onFilter={setFilteredInternalUsers}
        />

        <Container>
          <div className="content">
            <InternalUsersTableContainer>
              {loading ? (
                <Skeleton />
              ) : (
                <Container>
                  <>
                    {!restrictedToManageUsers && (
                      <AddUserContainer>
                        <Button
                          name="ShowAddUserModal"
                          onClick={() => setShowAddUserModal(true)}
                          variant="secondary"
                          disabled={!internalUsers}
                          icon={<Icon option="Plus" />}
                        >
                          Adicionar usuário
                        </Button>
                      </AddUserContainer>
                    )}
                  </>
                </Container>
              )}
              <InternalUsersTable
                internalUsers={filteredInternalUsers}
                setSellerReps={setInternalUsers}
              />
            </InternalUsersTableContainer>
          </div>
          {showAddUserModal && (
            <AddInternalUserModal
              onClose={() => setShowAddUserModal(false)}
              setSellerReps={setInternalUsers}
            />
          )}
        </Container>
      </InternalUsersManagementHeader>
    </>
  );
};

export default AccessInternalManagement;
